var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"pointermove":_vm.resize,"pointerup":_vm.stopResize}},[_vm._t("default",null,{"height":_vm.resizedSize.height + 'px',"isResized":_vm.isResized,"startResize":_vm.startResize,"width":_vm.resizedSize.width + 'px'})],2)}
var staticRenderFns = []

export { render, staticRenderFns }